@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.rides

import com.narbase.letsgo.dto.DtoName
import com.narbase.letsgo.web.dto.cartypes.CarTypeDto
import com.narbase.letsgo.web.dto.currency.CurrencyDto
import com.narbase.letsgo.web.dto.locationpoint.LocationPointDto
import com.narbase.letsgo.web.dto.rides.RideDto
import com.narbase.letsgo.web.models.CarCategory
import com.narbase.letsgo.web.models.CarColor

class PassengerRideDto(
    val ride: RideDto,
    val driver: DriverDetailsDto?,
    val carType: CarTypeDto?,
    val currency: CurrencyDto?,
    val shareToken: String?
)

class DriverDetailsDto(
    val fullName: String,
    val phone: String,
    val imageUrl: String?,
    val vehicle: String,
    val plate: String,
    val lat: Double,
    val lng: Double,
    val carModel: String?,
    val modelYear: Int?,
    val rating : Double?,
    val noOfReviews: Int?,
    @Suppress("NON_EXPORTABLE_TYPE") val carCategory: DtoName<CarCategory>?,
    @Suppress("NON_EXPORTABLE_TYPE") val carColor: DtoName<CarColor>?
    )

fun PassengerRideDto.getPickupLocationDto() : LocationPointDto {
    return LocationPointDto(
        lat = ride.pickupLat,
        lng = ride.pickupLng,
        address = ride.pickupAddress
    )
}
fun PassengerRideDto.getDestLocationDto() : LocationPointDto? {
    return LocationPointDto(
        lat = ride.destLat ?: return null,
        lng = ride.destLng ?: return null,
        address = ride.destAddress
    )
}